import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Center,
  Checkbox,
  Divider,
  Flex,
  Grid,
  GridItem,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
  Tooltip,
  useToast,
  VisuallyHidden,
} from "@chakra-ui/react";
import {
  DocIcon,
  FileIcon,
  RemoveIcon,
  EyeIcon,
} from "../../assets/svgs/Icons";
import { TiDelete } from "react-icons/ti";
import { MultiSelect } from "chakra-multiselect";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { FiUpload } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getProductCategory,
  getProductClassification,
} from "../../redux/product/ProductSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { getAllPrograms } from "../../redux/program/ProgramSlice";
import { getProgram, getSingleProgram } from "../../api";
import { identifier } from "@babel/types";
import axios from "axios";
import { PRODUCT_INITIAL_VALUES } from "../../Pages/RegistrationCertificate";
import dompurify from "dompurify";
import { checkFileTypesAndSize } from "../../Common/utils";

function RcForm3({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  handleSubmit,
  materials,
  setMaterials,
  products,
  setProducts,
  files,
  setFiles,
  setDeclare,
  commodityValues,
  setCommodityValues,
  selectedCommodityValue,
  setSelectedCommodityValue,
  customCommodityValue,
  setCustomCommodityValue,
  productValues,
  setProductValues,
  rc3error1,
  rc3error2,
  rc3error3,
  rc3error4,
  rc3error5,
  setRc3Error1,
  setRc3Error2,
  setRc3Error3,
  setRc3Error4,
  setRc3Error5,
  documents,
  setDocuments,
}) {
  const materialOptions = [
    "Elastine",
    "product2",
    "product3",
    "product4",
    "product5",
  ];

  const dispatch = useDispatch();

  const { productCategory } = useSelector((state) => state.products);
  const { productClassification } = useSelector((state) => state.products);
  const { allPrograms } = useSelector((state) => state.programs);
  const [program, setProgram] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedProgram, setSelectedProgram] = useState("");

  const addProducts = (productValues) => {
    if (productValues?.productName?.trim() === "") {
      setRc3Error1(true);
    }

    if (productValues?.productCategory === "") {
      setRc3Error2(true);
    }

    if (productValues?.productClassification === "") {
      setRc3Error3(true);
    }

    if (productValues?.productCertification === "") {
      setRc3Error4(true);
    }

    if (productValues?.productLabelGrade === "") {
      setRc3Error5(true);
    }

    if (
      productValues?.productName?.trim() !== "" &&
      productValues?.productCategory !== "" &&
      productValues?.productClassification !== "" &&
      productValues?.productCertification !== "" &&
      productValues?.productLabelGrade !== ""
    ) {
      const productObject = {
        id: uuidv4(),
        name: dompurify.sanitize(productValues.productName),
        productCategory: dompurify.sanitize(productValues.productCategory),
        productClassification: dompurify.sanitize(
          productValues.productClassification
        ),
        program: dompurify.sanitize(productValues.productCertification),
        certifiedLabelGrade: dompurify.sanitize(
          productValues.productLabelGrade
        ),
        productComposition: [
          {
            commodity: program?.program_labelGrade?.map(
              (grade) => grade.commodities.map((data) => data.commodityId.id)[0]
            ),
          },
        ],
        ncProductComposition: customCommodityValue.map((values) => ({
          commodity: values.id,
        })),
      };
      setProducts((product) => [productObject, ...product]);

      toast.success("Product added successfully");
      setProductValues(PRODUCT_INITIAL_VALUES);
      setProgram([]);
      setRc3Error5(false);
      setSelectedCommodityValue([]);
      setCustomCommodityValue([]);
    }
  };

  const saveEditChanges = () => {
    let productsCopy = [...products];
    const selectedProductIndex = productsCopy.findIndex(
      (product) => selectedProduct.id === product.id
    );
    productsCopy.splice(selectedProductIndex, 1, selectedProduct);
    setIsEditMode(false);
    setProducts([...productsCopy]);
    toast.success("Product Updated successfully");
  };

  const removeProducts = (id) => {
    setProducts((prev) => prev.filter((product) => product.id !== id));
    toast.success("Product removed successfully");
  };

  const getCategories = () => {
    try {
      const result = dispatch(getProductCategory());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getClassification = () => {
    try {
      const result = dispatch(getProductClassification());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getPrograms = () => {
    try {
      const result = dispatch(getAllPrograms());
      unwrapResult(result);
    } catch (error) {
      console.error(error);
      unwrapResult(error);
    }
  };

  const getOneProgram = async (id) => {
    let response = await getSingleProgram(id);
    setProgram(response?.data);
  };

  const getProductCategoryName = (productCategoryId) => {
    return productCategory?.data?.filter(
      (productCategory) => productCategory?._id === productCategoryId
    )?.[0]?.name;
  };

  const getProductClassificationName = (productClassificationId) => {
    return productClassification?.data?.filter(
      (productClassification) =>
        productClassification?._id === productClassificationId
    )?.[0]?.name;
  };

  const getProductCertificationName = (productCertificationId) => {
    return allPrograms?.data?.filter(
      (productCertification) =>
        productCertification?._id === productCertificationId
    )?.[0]?.name;
  };

  const getProductGradeName = (productGradeId) => {
    return program?.program_labelGrade?.filter(
      (productGrade) => productGrade?._id === productGradeId
    )?.[0]?.name;
  };

  const getCommodityName = (commodityId) => {
    return commodityValues.filter(
      (commodity) => commodity.id === commodityId
    )?.[0]?.value;
  };

  useEffect(() => {
    getCategories();
    getClassification();
    getPrograms();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFileUpload = async (event) => {
    const newFiles = Array.from(event.target.files);
    let errorMessage = "";
    let filesToAdd = [];

    for (let i = 0; i < newFiles.length; i++) {
      const file = newFiles[i];
      const validation = checkFileTypesAndSize(
        file.name,
        file.type,
        file.size,
        10485760
      );

      if (validation.isValid) {
        filesToAdd.push(file);
      } else {
        errorMessage = validation.error;
        break; // Exit the loop on the first invalid file
      }
    }

    if (errorMessage) {
      setErrorMessage(errorMessage);
      toast.error(errorMessage);
    } else {
      if (filesToAdd.length > 0) {
        setFiles([...filesToAdd, ...files]);
        toast.success("Your RC document uploaded successfully.");
        setErrorMessage("");
      } else {
        setErrorMessage("No files selected for upload.");
        toast.error("No files selected for upload.");
      }
    }
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const handleRemoveFile = (indexToRemove) => {
    setFiles(files.filter((_, index) => index !== indexToRemove));
  };

  const [isOpen, setIsOpen] = useState(false);

  const [selectedProduct, setSelectedProduct] = useState([]);
  const [showCertified, setShowCertified] = useState(false);
  const [editShowCertified, setEditShowCertified] = useState(false);

  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <>
      <Box bg="#fff" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          <Box
            as="span"
            borderRight={"3px solid #2272D5"}
            height="40px"
            marginRight={"1rem"}
          ></Box>
          Product Details
        </Text>

        <Box paddingLeft={{ base: "0", md: "3rem" }}>
          <Box>
            <Grid
              gap={"3rem"}
              templateColumns={{
                base: "1fr",
                md: "1fr",
                lg: "repeat(2, 1fr)",
              }}
              marginTop={"1rem"}
            >
              <GridItem colSpan={{ base: "2", md: "2", lg: "1" }}>
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent={"center"}
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem colSpan={{ base: "3", md: "2", lg: "1" }}>
                      <Text
                        color={"#141D43"}
                        fontSize="sm"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Product Name{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        border="2px solid  #8fd0fd !important"
                        marginTop="10px"
                        id="productName"
                        bg={"#fff"}
                        value={productValues.productName}
                        _focusVisible={
                          rc3error1
                            ? {
                                border: "1px solid red !important",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        onChange={(e) => {
                          setProductValues({
                            ...productValues,
                            productName: e.target.value,
                          });
                          if (e.target.value.trim() !== "") {
                            setRc3Error1(false);
                          }
                        }}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                        className={rc3error1 ? "error" : ""}
                        _active={
                          errors.productName && touched.productName
                            ? {
                                border: "1px solid red",
                              }
                            : { border: "1px solid #464C64" }
                        }
                      />
                      {/* {errors.productName && touched.productName && (
                        <Box color="red.500">{errors.productName}</Box>
                      )} */}
                      {rc3error1 && (
                        <Box
                          className="error-message"
                          color={"red"}
                          mt={"1rem"}
                        >
                          Product name is required
                        </Box>
                      )}
                    </GridItem>
                    <GridItem colSpan={{ base: "3", md: "2", lg: "1" }}>
                      <Text
                        color={"#141D43"}
                        fontSize="sm"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Product Category{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>
                      <Select
                        marginTop={"10px"}
                        bgColor="white"
                        color={" #464C64"}
                        border="2px solid  #8fd0fd !important"
                        id="productCategory"
                        fontSize="sm"
                        value={productValues.productCategory}
                        onChange={(e) => {
                          setProductValues({
                            ...productValues,
                            productCategory: e.target.value,
                          });
                          setRc3Error2(false);
                        }}
                      >
                        <option hidden="true">Select Product Category</option>
                        {productCategory?.data?.map((data, index) => (
                          <option default="true" value={data?._id} key={index}>
                            {data?.name}
                          </option>
                        ))}
                      </Select>
                      {rc3error2 && (
                        <Box
                          className="error-message"
                          color={"red"}
                          mt={"1rem"}
                        >
                          Product Category is required
                        </Box>
                      )}
                    </GridItem>
                    <GridItem colSpan={{ base: "3", md: "2", lg: "1" }}>
                      <Text
                        color={"#141D43"}
                        fontWeight={"700"}
                        fontSize="sm"
                        fontFamily={"font.roboto"}
                      >
                        Product Classification
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>
                      <Select
                        marginTop={"10px"}
                        bgColor="white"
                        color={" #464C64"}
                        border="2px solid  #8fd0fd !important"
                        id="productClassification"
                        fontSize="sm"
                        value={productValues.productClassification}
                        onChange={(e) => {
                          setProductValues({
                            ...productValues,
                            productClassification: e.target.value,
                          });
                          setRc3Error3(false);
                        }}
                      >
                        <option hidden="true">
                          Select Product Classification
                        </option>
                        {productClassification?.data?.map((data, index) => (
                          <option default="true" value={data?._id} key={index}>
                            {data?.name}
                          </option>
                        ))}
                      </Select>
                      {rc3error3 && (
                        <Box
                          className="error-message"
                          color={"red"}
                          mt={"1rem"}
                        >
                          Product Classification is required
                        </Box>
                      )}
                    </GridItem>
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    gap="3rem"
                  >
                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="sm"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Certification{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>
                      <Select
                        marginTop={"10px"}
                        bgColor="white"
                        color={" #464C64"}
                        border="2px solid  #8fd0fd !important"
                        id="productCertification"
                        fontSize="sm"
                        value={productValues.productCertification}
                        onChange={(e) => {
                          setProductValues({
                            ...productValues,
                            productCertification: e.target.value,
                          });
                          getOneProgram(e.target.value);
                          setRc3Error4(false);
                        }}
                      >
                        <option hidden="true">Select Certification</option>
                        {allPrograms?.data?.map((data, index) => (
                          <option default="true" value={data?._id} key={index}>
                            {data?.name}
                          </option>
                        ))}
                      </Select>
                      {rc3error4 && (
                        <Box
                          className="error-message"
                          color={"red"}
                          mt={"1rem"}
                        >
                          Certification is required
                        </Box>
                      )}
                    </GridItem>

                    <GridItem colSpan={1}>
                      <Text
                        color={"#141D43"}
                        fontSize="sm"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Grade{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>
                      <Select
                        marginTop={"10px"}
                        bgColor="white"
                        color={" #464C64"}
                        border="2px solid  #8fd0fd !important"
                        id="productLabelGrade"
                        fontSize="sm"
                        onChange={(e) => {
                          setProductValues({
                            ...productValues,
                            productLabelGrade: e.target.value,
                          });
                          setShowCertified(true);
                          setRc3Error5(false);
                        }}
                      >
                        <option hidden="true">Select Grade</option>
                        {program?.program_labelGrade?.map((data, index) => (
                          <option value={data?._id} key={index}>
                            {data?.name}
                          </option>
                        ))}
                      </Select>
                      {rc3error5 && (
                        <Box
                          className="error-message"
                          color={"red"}
                          mt={"1rem"}
                        >
                          Grade is required
                        </Box>
                      )}
                    </GridItem>
                  </Grid>
                  <Text
                    color={"#141D43"}
                    fontSize="lg"
                    marginTop={"2rem"}
                    width="100%"
                    fontWeight={"800"}
                    fontFamily={"font.roboto"}
                    borderBottom="2px solid #52BBFF"
                  >
                    Product Composition
                  </Text>

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    gap="3rem"
                    marginTop={"1rem"}
                    alignItems={"center"}
                  >
                    <GridItem colSpan={{ base: "2", lg: "2", xl: "1" }}>
                      <Text
                        color={"#141D43"}
                        fontSize="sm"
                        fontWeight={"800"}
                        fontFamily={"font.roboto"}
                      >
                        Certified Materials
                      </Text>
                      {/* <Input
                        disabled
                        opacity={"1 !important"}
                        bgColor="white"
                        marginTop={"10px"}
                        color={" #464C64"}
                        border="none"
                        fontSize="sm"
                        value={program?.program_labelGrade?.commodities?.map(
                          (data, index) => data?.commodityId?.name
                        )}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      /> */}
                      {program?.program_labelGrade?.length > 0 && showCertified
                        ? program?.program_labelGrade?.map((data, index) => (
                            <>
                              {data?.commodities?.map((data) => (
                                <Text
                                  fontWeight={"700"}
                                  fontFamily={"font.roboto"}
                                  marginTop="1rem"
                                >
                                  {data?.commodityId?.name !== ""
                                    ? data?.commodityId?.name
                                    : ""}
                                </Text>
                              ))}
                            </>
                          ))
                        : "N/A"}
                    </GridItem>

                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="sm"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Non Certified Material
                      </Text>
                      <MultiSelect
                        marginTop={"10px"}
                        options={commodityValues}
                        value={selectedCommodityValue}
                        bgColor="white"
                        color={" #464C64"}
                        onChange={(value) => {
                          const newArr = value.map(
                            (value) =>
                              commodityValues.filter(
                                (commodity) => commodity.label === value
                              )[0]
                          );
                          setCustomCommodityValue(newArr);
                          setSelectedCommodityValue(value);
                        }}
                      />
                    </GridItem>
                    {/* <GridItem marginTop={"2.2rem"}>
                    <Button
                      w="120px"
                      bg="#52BBFF"
                      color={"#fff"}
                      _hover={{ bg: "#52BBFF" }}
                    >
                      <DocIcon width="25px" height="25px" />
                    </Button>
                  </GridItem> */}
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                        mt="1rem"
                      >
                        To add more Product please click button below
                      </Text>
                      <Button
                        bg={"#52BBFF"}
                        _hover={{ bg: "#3fa7eb" }}
                        onClick={() => addProducts(productValues)}
                        color="white"
                        cursor={"pointer"}
                        mt="1rem"
                      >
                        Add Product
                      </Button>
                    </GridItem>
                  </Grid>
                </Box>
              </GridItem>

              {/* <GridItem colSpan={1}>
              <Divider w="10px" orientation="vertical" borderRadius={"15px"} borderWidth="2px" borderColor="#b8def8" bg="#b8def8" margin={"auto"}/>
              </GridItem> */}

              <GridItem
                colSpan={{ base: "2", md: "2", lg: "1" }}
                height={{ base: "auto", md: "400px" }}
                overflowY={products?.length > 3 ? "scroll" : "auto"}
                className="overflow-style"
                borderLeft={{ base: "", md: "", lg: "3px solid #52BBFF" }}
                paddingLeft={{ base: "", md: "", lg: "2rem" }}
              >
                <Text
                  color={"#141D43"}
                  fontSize="lg"
                  fontWeight={"800"}
                  marginBottom="5px"
                >
                  List of Products added
                </Text>
                <Box
                  border={"2px solid #2272D5"}
                  width="15%"
                  marginBottom={"1rem"}
                ></Box>
                <Box>
                  <Box
                    display={"flex"}
                    flexDirection="column"
                    alignItems="flex-start"
                    justifyContent={"center"}
                  >
                    <Grid
                      width={"100%"}
                      templateColumns="repeat(1, 1fr)"
                      mt="8px"
                      gap="3rem"
                    >
                      <GridItem width={"100%"}>
                        {products?.length > 0 ? (
                          products
                            .sort((a, b) => a.id - b.id)
                            ?.map((data) => (
                              <Card
                                w={"100%"}
                                height="150px"
                                backgroundColor={"#fff"}
                                boxShadow={
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                                }
                                mb="1.5rem"
                              >
                                <Box padding={"1rem"}>
                                  <Box>
                                    <Box
                                      display={"flex"}
                                      justifyContent="space-between"
                                      mt="7px"
                                    >
                                      <Text
                                        color={"#2272D5"}
                                        fontWeight={"600"}
                                      >
                                        Product Details
                                      </Text>
                                      <Box
                                        onClick={() => removeProducts(data?.id)}
                                        cursor="pointer"
                                      >
                                        <TiDelete
                                          fontSize={"28px"}
                                          color="crimson"
                                        />
                                      </Box>
                                    </Box>

                                    <Grid
                                      width={"100%"}
                                      templateColumns="repeat(5, 1fr)"
                                      my={"1rem"}
                                      gap="10px"
                                    >
                                      <GridItem colSpan={2}>
                                        <Text
                                          color={"#141D43"}
                                          fontSize={{
                                            base: "sm",
                                            lg: "sm",
                                            xl: "md",
                                          }}
                                          fontWeight={"800"}
                                        >
                                          Product Name
                                        </Text>
                                        <Text color={"#141D43"} fontSize="md">
                                          {data.name ? data.name : "N/A"}
                                        </Text>
                                      </GridItem>
                                      <GridItem colSpan={2}>
                                        <Text
                                          color={"#141D43"}
                                          fontSize={{
                                            base: "sm",
                                            lg: "sm",
                                            xl: "md",
                                          }}
                                          fontWeight={"800"}
                                        >
                                          Product Category
                                        </Text>
                                        <Text color={"#141D43"} fontSize="md">
                                          {" "}
                                          {data?.productCategory
                                            ? getProductCategoryName(
                                                data?.productCategory
                                              )
                                            : "N/A"}
                                        </Text>
                                      </GridItem>
                                      <GridItem colSpan={1}>
                                        <Tooltip label="View Product Details!">
                                          <Button
                                            bg="#FFFFFF"
                                            onClick={() => {
                                              setIsOpen(true);
                                              setSelectedProduct(data);
                                            }}
                                            leftIcon={<EyeIcon />}
                                          ></Button>
                                        </Tooltip>
                                      </GridItem>
                                    </Grid>
                                  </Box>
                                </Box>
                              </Card>
                            ))
                        ) : (
                          <Box marginTop={"3rem"}>
                            <Text
                              color={"#141D43"}
                              fontSize="lg"
                              fontWeight={"800"}
                            >
                              Added Product cards will appear here
                            </Text>
                          </Box>
                        )}
                      </GridItem>
                    </Grid>
                  </Box>
                </Box>
              </GridItem>
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box mt="2rem">
        <Box mt="1rem" mb="1rem">
          <Text fontSize="md" fontWeight={"800"}>
            Upload GST/Company Document
          </Text>
        </Box>
        <Grid templateColumns={{ base: "1fr", md: "repeat(5,1fr)" }} gap={4}>
          <GridItem colSpan={1}>
            <Button
              w={"100%"}
              h={"150px"}
              bg={"#FFFFFF"}
              leftIcon={<FiUpload />}
              borderRadius={"15px"}
              as="label"
              htmlFor="file-upload"
              variant="outline"
            >
              Upload files
              <VisuallyHidden>
                <input
                  id="file-upload"
                  type="file"
                  multiple
                  onChange={(event) => handleFileUpload(event)}
                />
              </VisuallyHidden>
            </Button>
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 4 }}>
            <Box
              display={"flex"}
              overflowX={files?.length > 4 ? "scroll" : "auto"}
              maxWidth="100%"
              className="overflow-style"
            >
              {files.map((file, index) => (
                <Box
                  bg="#FFFFFF"
                  key={index}
                  minW={"200px"}
                  h={"150px"}
                  borderRadius={"15px"}
                  mx={"1rem"}
                >
                  <Box display={"flex"} justifyContent={"right"}>
                    <Button
                      borderColor="#FFFFFF"
                      bg="#ffffff"
                      size="sm"
                      variant="outline"
                      onClick={() => handleRemoveFile(index)}
                      leftIcon={<RemoveIcon />}
                    ></Button>
                  </Box>
                  <Tooltip label={file.name}>
                    <Box>
                      <Box display={"flex"} justifyContent={"center"}>
                        <FileIcon />
                      </Box>

                      <Text
                        width={"130px"}
                        whiteSpace={"nowrap"}
                        overflow={"hidden"}
                        textOverflow={"ellipsis"}
                        m="1rem auto"
                      >
                        {file.name}
                      </Text>
                    </Box>
                  </Tooltip>
                </Box>
              ))}
            </Box>
          </GridItem>
        </Grid>
        <Box display={"flex"} justifyContent={"center"}>
          {errorMessage && (
            <Box
              bg="crimson"
              color="white"
              p="1rem"
              borderRadius="15px"
              mb="1rem"
              w="60%"
              textAlign={"center"}
            >
              {errorMessage}
              <Button
                size="sm"
                variant="outline"
                ml="1rem"
                bg="white"
                color="black"
                onClick={clearErrorMessage}
              >
                <RemoveIcon />
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      <Box bg="#fff" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          Declaration of the body issuing the certificate:
        </Text>
        <Box paddingLeft={"0rem"}>
          <Box>
            <Grid
              gap={"3rem"}
              templateColumns="repeat(1, 1fr)"
              marginTop={"1rem"}
            >
              <GridItem colSpan={1}>
                <Checkbox
                  borderColor={"var(--chakra-colors-checkbox-500)"}
                  colorScheme={"checkbox"}
                  fontWeight="800"
                  size="lg"
                  onChange={(e) => setDeclare(e.target.checked)}
                >
                  Undersigned declares to have completed this application form
                  truthfully. I accept the validity and authenticity of above
                  information in application form.
                </Checkbox>
              </GridItem>
              {/* <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Additional Decleration
                </Text>
                <Textarea
                  type="tel"
                  color={"#B8DEF8"}
                  border="none"
                  marginTop="10px"
                  bg={"#fff"}
                  placeholder="Certification of the organic material used for the products listed complies with:"
                  fontSize={"14px"}
                  _placeholder={{
                    opacity: 1,
                    color: " #464C64",
                    fontSize: "14px",
                  }}
                />
              </GridItem> */}
            </Grid>
          </Box>
        </Box>
      </Box>

      <Modal
        size={"xl"}
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setIsEditMode(false);
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <Grid
            templateColumns={{ base: "repeat(2,1fr)", md: "repeat(2,1fr)" }}
            gap={2}
          >
            <GridItem colSpan={2}>
              <ModalHeader color="#2272D5">Product Details</ModalHeader>
            </GridItem>
            <GridItem>
              <Button
                bg="#ffffff"
                mt="0.7rem"
                ml="15rem"
                leftIcon={<RemoveIcon />}
                onClick={() => setIsOpen(false)}
              ></Button>
            </GridItem>
          </Grid>
          <ModalBody>
            <Box>
              <Grid
                mt="1rem"
                templateColumns={{ base: "1fr", md: "repeat(3,1fr)" }}
                gap={2}
              >
                <GridItem>
                  <Text fontSize="sm" color={"#141D43"} fontWeight={"800"}>
                    Product Name
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedProduct?.name ? selectedProduct?.name : "N/A"}
                    </Text>
                  ) : (
                    <Input
                      value={selectedProduct?.name}
                      onChange={(e) =>
                        setSelectedProduct({
                          ...selectedProduct,
                          name: e.target.value,
                        })
                      }
                    />
                  )}
                </GridItem>
                <GridItem>
                  <Text fontSize="sm" color={"#141D43"} fontWeight={"800"}>
                    Product Category
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedProduct?.productCategory
                        ? getProductCategoryName(
                            selectedProduct?.productCategory
                          )
                        : "N/A"}
                    </Text>
                  ) : (
                    <Select
                      bgColor="white"
                      color={" #464C64"}
                      border="2px solid  #8fd0fd !important"
                      id="productCategory"
                      fontSize="sm"
                      value={selectedProduct?.productCategory}
                      onChange={(e) =>
                        setSelectedProduct({
                          ...selectedProduct,
                          productCategory: e.target.value,
                        })
                      }
                    >
                      <option hidden="true">Select Product Category</option>
                      {productCategory?.data?.map((data, index) => (
                        <option default="true" value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  )}
                </GridItem>
                <GridItem>
                  <Text fontSize="sm" color={"#141D43"} fontWeight={"800"}>
                    Product Classification
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedProduct?.productClassification
                        ? getProductClassificationName(
                            selectedProduct?.productClassification
                          )
                        : "N/A"}
                    </Text>
                  ) : (
                    <Select
                      bgColor="white"
                      color={" #464C64"}
                      border="2px solid  #8fd0fd !important"
                      id="productClassification"
                      fontSize="sm"
                      value={selectedProduct.productClassification}
                      onChange={(e) => {
                        setSelectedProduct({
                          ...selectedProduct,
                          productClassification: e.target.value,
                        });
                      }}
                    >
                      <option hidden="true">
                        Select Product Classification
                      </option>
                      {productClassification?.data?.map((data, index) => (
                        <option default="true" value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  )}
                </GridItem>
              </Grid>

              <Grid
                mt="2rem"
                templateColumns={{ base: "1fr", md: "repeat(2,1fr)" }}
                gap={"2rem"}
              >
                <GridItem>
                  <Text fontSize="sm" color={"#141D43"} fontWeight={"800"}>
                    Certification
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedProduct?.program
                        ? getProductCertificationName(selectedProduct?.program)
                        : "N/A"}
                    </Text>
                  ) : (
                    <Select
                      bgColor="white"
                      color={" #464C64"}
                      border="2px solid  #8fd0fd !important"
                      id="productCertification"
                      fontSize="sm"
                      value={selectedProduct?.program}
                      onChange={(e) => {
                        const selectedProgramId = e.target.value;
                        const selectedProgram = allPrograms.data.find(
                          (data) => data._id === selectedProgramId
                        );

                        const productComposition =
                          selectedProgram?.program_labelGrade?.map((grade) => ({
                            commodity: grade.commodities.map(
                              (data) => data.commodityId.id
                            ),
                          })) || [{ commodity: [] }];

                        setSelectedProduct((prevSelectedProduct) => ({
                          ...prevSelectedProduct,
                          program: selectedProgramId,
                          productComposition:
                            productComposition.length > 0
                              ? productComposition
                              : [{ commodity: [] }],
                        }));

                        setSelectedProgram(selectedProgramId);
                      }}
                    >
                      <option hidden="true">Select Certification</option>
                      {allPrograms?.data?.map((data, index) => (
                        <option default="true" value={data?._id} key={index}>
                          {data?.name}
                        </option>
                      ))}
                    </Select>
                  )}
                </GridItem>

                <GridItem>
                  <Text fontSize="sm" color={"#141D43"} fontWeight={"800"}>
                    Grade
                  </Text>
                  {!isEditMode ? (
                    <Select
                      marginTop={"10px"}
                      bgColor="white"
                      disabled={true}
                      color={" #464C64"}
                      border="2px solid  #8fd0fd !important"
                      id="productLabelGrade"
                      fontSize="sm"
                      value={selectedProduct?.certifiedLabelGrade}
                      onChange={(e) => {
                        setSelectedProduct({
                          ...selectedProduct,
                          certifiedLabelGrade: e.target.value,
                        });

                        setEditShowCertified(true);
                      }}
                    >
                      <option hidden="true">Select Grade</option>
                      {selectedProduct?.program &&
                        allPrograms?.data
                          ?.find((data) => data._id === selectedProduct.program)
                          ?.program_labelGrade.map((data, index) => (
                            <option value={data._id} key={index}>
                              {data.name}
                            </option>
                          ))}
                    </Select>
                  ) : (
                    <Select
                      marginTop={"10px"}
                      bgColor="white"
                      color={" #464C64"}
                      border="2px solid  #8fd0fd !important"
                      id="productLabelGrade"
                      fontSize="sm"
                      value={selectedProduct?.certifiedLabelGrade}
                      onChange={(e) => {
                        setSelectedProduct({
                          ...selectedProduct,
                          certifiedLabelGrade: e.target.value,
                        });
                        setEditShowCertified(true);
                      }}
                    >
                      <option hidden="true">Select Grade</option>
                      {selectedProduct?.program &&
                        allPrograms?.data
                          ?.find((data) => data._id === selectedProduct.program)
                          ?.program_labelGrade.map((data, index) => (
                            <option value={data._id} key={index}>
                              {data.name}
                            </option>
                          ))}
                    </Select>
                  )}
                </GridItem>
              </Grid>

              <Grid
                mt="2rem"
                templateColumns={{ base: "1fr", md: "repeat(2,1fr)" }}
                gap={"2rem"}
              >
                <GridItem>
                  <Text
                    color={"#141D43"}
                    fontSize="sm"
                    fontWeight={"800"}
                    fontFamily={"font.roboto"}
                  >
                    Certified Materials
                  </Text>
                  {/* Accessing and mapping the data array */}
                  {(() => {
                    let matchingCommodities = []; // Array to store matching commodity names

                    allPrograms?.data?.forEach((program) => {
                      // Checking if the object's _id matches with selectedProduct
                      if (program?._id === selectedProduct?.program) {
                        // Accessing the program_labelGrade array
                        program?.program_labelGrade?.forEach((labelGrade) => {
                          // Mapping the commodities array
                          labelGrade?.commodities?.forEach((commodity) => {
                            matchingCommodities.push(
                              commodity?.commodityId?.name
                            );
                          });
                        });
                      }
                    });

                    if (matchingCommodities.length === 0) {
                      return <Text>N/A</Text>; // Render "N/A" if no matches were found
                    }

                    return matchingCommodities?.map((commodityName, index) => (
                      <Text key={index}>{commodityName}</Text>
                    ));
                  })()}
                </GridItem>

                <GridItem>
                  <Box>
                    <Text
                      color={"#141D43"}
                      fontSize="sm"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Non Certified Material
                    </Text>

                    {!isEditMode ? (
                      <Text>
                        {selectedProduct?.ncProductComposition?.length === 0
                          ? "N/A"
                          : selectedProduct?.ncProductComposition
                              ?.map((comp) => {
                                const matchingCommodity = commodityValues.find(
                                  (commodity) => commodity.id === comp.commodity
                                );
                                return matchingCommodity
                                  ? matchingCommodity.label
                                  : "N/A";
                              })
                              .join(", ")}
                      </Text>
                    ) : (
                      <MultiSelect
                        marginTop={"10px"}
                        options={commodityValues}
                        value={selectedProduct?.ncProductComposition?.map(
                          (comp) => {
                            const matchingCommodity = commodityValues.find(
                              (commodity) => commodity.id === comp.commodity
                            );
                            return matchingCommodity
                              ? matchingCommodity.label
                              : "";
                          }
                        )}
                        onChange={(values) => {
                          const newArr = values.map(
                            (value) =>
                              commodityValues.filter(
                                (commodity) => commodity.label === value
                              )[0]
                          );

                          const updatedComposition = newArr.map((value) => ({
                            commodity: value?.id,
                          }));
                          setSelectedProduct((prevProduct) => ({
                            ...prevProduct,
                            ncProductComposition: updatedComposition,
                          }));
                        }}
                        bgColor="white"
                        color={"#464C64"}
                        border="2px solid #8fd0fd !important"
                        placeholder="Select Non-Certified Materials"
                      />
                    )}
                  </Box>
                </GridItem>
              </Grid>
            </Box>
          </ModalBody>
          <ModalFooter>
            {!isEditMode ? (
              <Button
                bg="#2272D5"
                color="#ffffff"
                _hover={{ backgroundColor: "#2272D5" }}
                onClick={() => setIsEditMode(true)}
              >
                Edit
              </Button>
            ) : (
              <>
                <Button
                  bg="#2272D5"
                  color="#ffffff"
                  _hover={{ backgroundColor: "#2272D5" }}
                  onClick={() => saveEditChanges()}
                >
                  Save
                </Button>
                <Button
                  bg="#C4C4C4"
                  color="#ffffff"
                  _hover={{ backgroundColor: "#C4C4C4" }}
                  ml="1rem"
                  onClick={() => {
                    setIsEditMode(false);
                  }}
                >
                  Cancel
                </Button>
              </>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default RcForm3;
